import FlagAllowanceSpecs from "./FlagAllowanceSpecs";
export default FlagAllowanceSpecs;
